import { TAlert, TAlert_LEGACY } from '../types';
import { SLACK_ALERT_TRIGGER } from '../constants';

export const alertIsoLegacyAlert: Iso<TAlert, TAlert_LEGACY> = {
  get: (alert) => ({
    _id: alert.id,
    _disabled: alert.disabled,
    _frequency: alert.frequency,
    _message: alert.message,
    _name: alert.name,
    _recipients: alert.recipients,
    _time: alert.time,
    _viewSeries: alert.seriesId,
    _trigger:
      alert.trigger === SLACK_ALERT_TRIGGER.newOrChangedResults
        ? SLACK_ALERT_TRIGGER.newResults
        : alert.trigger,
    _showChanged: alert.trigger === SLACK_ALERT_TRIGGER.newOrChangedResults,
  }),
  reverseGet: (alert_LEGACY) => ({
    id: alert_LEGACY._id,
    disabled: alert_LEGACY._disabled,
    frequency: alert_LEGACY._frequency,
    message: alert_LEGACY._message,
    name: alert_LEGACY._name,
    recipients: alert_LEGACY._recipients,
    time: alert_LEGACY._time,
    // TODO: fix the enum on BE side to get rid of this logic...
    trigger:
      alert_LEGACY._trigger === SLACK_ALERT_TRIGGER.newResults &&
      alert_LEGACY._showChanged
        ? SLACK_ALERT_TRIGGER.newOrChangedResults
        : alert_LEGACY._trigger,
    seriesId: alert_LEGACY._viewSeries,
  }),
};
